import { ReactNode, createContext, useContext, useMemo } from 'react';

type SubagentPanelContextValue = {
  openSubagentPanel: (childChatName: string) => void;
};

const SubagentPanelContext = createContext<SubagentPanelContextValue | null>(
  null,
);

export const SubagentPanelProvider = ({
  openSubagentPanel,
  children,
}: SubagentPanelContextValue & { children: ReactNode }) => {
  const value = useMemo(() => ({ openSubagentPanel }), [openSubagentPanel]);
  return (
    <SubagentPanelContext.Provider value={value}>
      {children}
    </SubagentPanelContext.Provider>
  );
};

export const useSubagentPanel = () => useContext(SubagentPanelContext);
